import {AxiosServer, ArrRemoveSubItem, AxiosEsb} from '../../utils';
import {server} from '../../config/serverConfig';
import {message,Statistic} from 'antd';
import clientRecommendRd from "../reducers/clientRecommendRd";
import derClientRecommendRd from "../reducers/derClientRecommendRd";

let namespace = 'derClientRecommend_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

function format(input) {
	var n = parseFloat(input).toFixed(2);
	var re = /(\d{1,3})(?=(\d{3})+(?:\.))/g;
	return n.replace(re, "$1,");
}


const derClientRecommendAc ={
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},
	
	GET:(value)=>(dispatch,getState)=>{
		
		let store =getState().derClientRecommendRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}
		let Axios = AxiosServer();

		return Axios.post('/derClientRecommend/findAll',dataFetchProps).then((res)=>{
						
			if (res.data.status == true){
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}});  
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('userlist ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})},


	CREATE:(value)=>(dispatch,getState)=>{

		//value 是传过来的参数
		//getState 可获取当前store的状态

		let Axios = AxiosServer();

		return  Axios.post('/derClientRecommend/create',value).then((res)=>{
			console.log(res.data)

			if (res.data.status===true){
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '添加成功'
			}else{
				return '添加失败'
			}

		}).catch((err)=>{
			console.log('err:',err);
		});

	},



	RECOMMEND:(value)=>(dispatch,getState)=>{


		let Axios = AxiosEsb();
		value.clientType='采购宝';
		return Axios.post('/api/towxsbank/submitPreCreditInfo',value).then((res)=>{

			if (res.data.status == true){

				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true

				return '推送银行处理,等待20秒刷新';
			}

		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});
			return '错误'
		})
	},


	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错	
		let currentState =getState().derClientRecommendRd;
		value.id = parseInt(value.id);		
		let Axios = AxiosServer();
		return  Axios.post('/derClientRecommend/update',value).then((res)=>{
			
		   dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});	
			
		//   dispatch(userlist_GET({order:[['id']]}));
		   return '更新成功'
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},


}



export {derClientRecommendAc};